module.exports = {
  title: 'React Native Scroll Progress Animation 📜',
  author: 'Enzo Manuel Mangano',
  date: '2022-12-28',
  slug: 'scroll-progress',
  tags: ['reanimated'],
};
